/*
 * @Date: 2022-07-04 17:27:28
 * @LastEditors: chuhongguang
 */
const files = require.context('./modules', false, /\.js$/)

const modules = {}

files.keys().forEach(key => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})


export default {
    ...modules
}
